import { faArrowLeftLong } from '@fortawesome/pro-light-svg-icons';
import {
  faArrowRightFromBracket,
  faGear,
} from '@fortawesome/pro-regular-svg-icons';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { signOutUser } from '../../slices/AuthSlice';
import { useAppDispatch } from '../../slices/store';
import { RootState } from '../../types';
import { cn } from '../../utils/classUtils';
import Avatar from '../Avatar';
import Hover from '../Hover';

import ConfigDrivenContainerLayoutHeaderNavLink from './ConfigDrivenContainerLayoutHeaderNavLink';

interface ConfigDrivenContainerLayoutHeaderProps {
  hideMyLoans?: boolean;
  hideMyTasks?: boolean;
  showOnlyBackButton?: boolean;
}

const ConfigDrivenContainerLayoutHeader: FC<
  ConfigDrivenContainerLayoutHeaderProps
> = ({ hideMyLoans, hideMyTasks, showOnlyBackButton }) => {
  const { borrowerId } = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { authUserDetail } = useSelector((state: RootState) => ({
    authUserDetail: state.auth.authUserDetail,
  }));

  return (
    <div className='lg:flex hidden flex-row p-4 bg-white border-b border-silver sticky top-0 right-0 z-50'>
      <div
        className={cn('flex flex-row flex-1 justify-between gap-x-5', {
          'flex-row-reverse': hideMyLoans,
        })}
      >
        {!hideMyLoans && !showOnlyBackButton && (
          <ConfigDrivenContainerLayoutHeaderNavLink
            label='My Loans'
            path='/loans'
            leftIcon={faArrowLeftLong}
          />
        )}
        {showOnlyBackButton && (
          <ConfigDrivenContainerLayoutHeaderNavLink
            label='Back'
            path='#'
            onClick={() => navigate(-1)}
            leftIcon={faArrowLeftLong}
          />
        )}
        <div className='flex flex-row items-center'>
          {!hideMyTasks && borrowerId && !showOnlyBackButton && (
            <ConfigDrivenContainerLayoutHeaderNavLink
              label='My Tasks'
              path={`/pre-approval-form/${borrowerId}/tasks`}
            />
          )}
          {borrowerId && !showOnlyBackButton && (
            <ConfigDrivenContainerLayoutHeaderNavLink
              label='File Cabinet'
              path={`/pre-approval-form/${borrowerId}/file-cabinet`}
            />
          )}
          <Hover
            config={{
              placement: 'top-end',
              trigger: 'click',
              interactive: true,
              closeOnOutsideClick: false,
              visible: isOpen,
            }}
            hoverComponent={
              <div className='flex flex-col'>
                <ConfigDrivenContainerLayoutHeaderNavLink
                  path='/security-settings'
                  label='Security Settings'
                  leftIcon={faGear}
                />
                <ConfigDrivenContainerLayoutHeaderNavLink
                  path='#'
                  label='Logout'
                  leftIcon={faArrowRightFromBracket}
                  onClick={async () => {
                    await dispatch(signOutUser());
                    navigate('/');
                  }}
                />
              </div>
            }
          >
            <div
              onClick={() => setIsOpen(!isOpen)}
              className={cn(
                'border w-[66px] h-[38px] flex justify-between items-center rounded-full py-1.5 px-2 cursor-pointer',
                !isOpen ? ' border-silver' : 'border-dark',
              )}
            >
              <Avatar
                name={authUserDetail?.fullName!}
                imageUrl={authUserDetail?.avatar}
                size='sm'
              />
              <p>
                <FontAwesomeIcon
                  icon={isOpen ? faChevronUp : faChevronDown}
                  className='text-sm'
                />
              </p>
            </div>
          </Hover>
        </div>
      </div>
    </div>
  );
};

export default ConfigDrivenContainerLayoutHeader;
